import {
    isItemHeldByConversationItemParts,
    isItemHeldByItemReadingPane,
} from './tryRemoveFromMailStoreItemsMutator';
import tryRemoveItemNormalizedBody from 'owa-mail-actions/lib/table-loading/tryRemoveItemNormalizedBody';
import { RemoveItemSource } from 'owa-mail-actions/lib/triage/tryRemoveFromMailStoreItems';
import Item from 'owa-service/lib/contract/Item';
import { mutator } from 'satcheljs';

export default mutator(tryRemoveItemNormalizedBody, actionMessage => {
    const item: Item = actionMessage.item;

    if (
        isItemHeldByConversationItemParts(item.ConversationId.Id, RemoveItemSource.ListViewTable) ||
        isItemHeldByItemReadingPane(item.ItemId.Id, RemoveItemSource.ListViewTable)
    ) {
        // The item reference is currently held, we cannot remove normalized body at this time
        // We don’t need to check listview reference because this is only a listview scenario, i.e reload
        // where we need to remove the NormalizedBody from item
        return;
    }

    // Delete the normalizedBody of the item
    item.NormalizedBody = undefined;
});
